import { useEffect } from 'react';
import { FilterQuery, OrderBy, OrderBySortParameters } from '../../consts';
import { useDebouncedValue, useFilter, useJSONFilter, useQueryParam } from '../../utils/hooks';
import { useUsersSearch } from '../users/userQueries';
const resultsPerPage = 12;
export const useDirectoryUsers = () => {
  const [pageNumberParam, setPage] = useQueryParam('page');
  const {
    selectedItems: products
  } = useFilter(FilterQuery.products);
  const {
    selectedItems: goals
  } = useFilter(FilterQuery.goals);
  const {
    selectedItems: orderBy
  } = useFilter(FilterQuery.orderBy);
  const {
    selectedObjects: locations
  } = useJSONFilter(FilterQuery.location);
  const {
    selectedObjects: industries
  } = useJSONFilter(FilterQuery.industry);
  const {
    selectedObjects: companies
  } = useJSONFilter(FilterQuery.company);
  const [searchParam] = useQueryParam(FilterQuery.search);
  const debouncedSearchParam = useDebouncedValue(searchParam, 500);
  useEffect(() => {
    setPage();
  }, [debouncedSearchParam, setPage]);
  const pageNumber = Number(pageNumberParam) || 1;
  const selectedOrder = orderBy.length ? orderBy[0] : OrderBy.Recent;
  const {
    users,
    totalPages,
    totalUsers,
    usersLoading,
    usersError
  } = useUsersSearch({
    page: pageNumber,
    resultsPerPage,
    query: debouncedSearchParam,
    products,
    goals,
    geolocationId: locations.length ? locations[0].id : undefined,
    industryId: industries.length ? industries[0].id : undefined,
    companyId: companies.length ? companies[0].id : undefined,
    sortProperty: OrderBySortParameters[selectedOrder][0],
    sortOrder: OrderBySortParameters[selectedOrder][1]
  });
  return {
    users,
    totalPages,
    totalUsers,
    usersLoading,
    usersError,
    pageNumber,
    resultsPerPage
  };
};